import { render, staticRenderFns } from "./FundHelplist.vue?vue&type=template&id=53817b9f&"
import script from "./FundHelplist.vue?vue&type=script&lang=js&"
export * from "./FundHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports